<template>
  <GlobalModal ref="globalModal" />
  <router-view />
</template>

<script>
import GlobalModal from "./components/GlobalModal.vue";
import { modalRef } from "./composables/useGlobalModal";

export default {
  components: { GlobalModal },
  mounted() {
    modalRef.value = this.$refs.globalModal;
  },
};
</script>
